import { Box, Typography } from '@mui/material'
import { SxProps } from '@mui/system'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import Loader from 'src/components/shared/ui/Loader/Loader'
import { Company, Mensaje } from 'src/interfaces'
import { getCompanies } from 'src/services/CompaniesService'
import AssignExpedientForm from './AssignExpedientForm'

const styles: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-around',
  width: '100%',
  minHeight: '100px'
}

type Props = {
  message: Mensaje
  onCancel: () => void
  onAssigned: () => void
}

function AssignExpedient({ message, onAssigned, onCancel }: Props): JSX.Element {
  const { t } = useTranslation()

  const companiesQuery = useQuery(['companies'], () => getCompanies())

  if (companiesQuery.isLoading) {
    return (
      <Box component="div" sx={styles}>
        <Loader />
      </Box>
    )
  }

  if (companiesQuery.isError) {
    return (
      <Box component="div" sx={styles}>
        <Typography color="error">{t('general.error_message')}</Typography>
      </Box>
    )
  }

  const companies = companiesQuery.data?.results as Company[]

  return (
    <Box component="div" sx={styles}>
      <AssignExpedientForm
        message={message}
        onAssigned={onAssigned}
        onCancel={onCancel}
        companies={companies}
      />
    </Box>
  )
}

export default AssignExpedient
